
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/create/search",
      function () {
        return require("private-next-pages/embed/create/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/create/search"])
      });
    }
  